export default "__VITE_ASSET__f935d3f1__"